import Image from './Image';
import React from 'react';
import styled, { keyframes } from 'styled-components';
const LoaderImage = (props) => {
    return (React.createElement(RotateWrapper, { ...props },
        React.createElement(Rotate, null,
            React.createElement(Image, { ...props, alt: 'Loading...', src: LoaderSvgData }))));
};
export const LoaderSvgData = `data:image/svg+xml;utf8,<svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
     preserveAspectRatio="xMidYMid">
    <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="40" stroke-width="10" stroke="rgb(0,139,214)"
            stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(291.927 50 50)" class="">
    </circle>
</svg>
`;
export const WhiteLoaderSvgData = `data:image/svg+xml;utf8,<svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <circle
        cx="50"
        cy="50"
        fill="none"
        stroke-linecap="round"
        r="40"
        stroke-width="10"
        stroke="rgb(255,255,255)"
        stroke-dasharray="62.83185307179586 62.83185307179586"
        transform="rotate(291.927 50 50)"
    >
        <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
            dur="0.8s"
            begin="0s"
            repeatCount="indefinite">
        </animateTransform>
    </circle>
</svg>`;
const rotate = keyframes `
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;
const Rotate = styled.div `
    animation: ${rotate} 0.8s linear infinite;
`;
const RotateWrapper = styled.div `
`;
export default LoaderImage;
//# sourceMappingURL=LoaderImage.js.map